@let items = (coinOptions$ | async) ?? [];

<lib-select
  [style.height.%]="100"
  [options]="items"
  [formControl]="control"
  [labelTranslateKey]="labelTranslateKey"
  [searchTranslateKey]="searchTranslateKey"
  [isClearable]="isClearable"
  [fullWidth]="fullWidth"
  [isSearchDisplayed]="true"
  [isOptionListLoading]="coinDictionaryService.isLoading()"
/>
